// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 0;
}

:root {
  --color-blue: rgb(053, 151, 236);
  --color-green: rgb(000, 168, 155);
  --color-orange: rgb(247, 148, 030);
}

a {
  color: black;
  text-decoration: underline;
}

.active-label {
  font-weight: bold;
  text-decoration: none;
}

.current {
  font-weight: bold;
  text-decoration: none;
}

.progress-bar {
  display: inline-block;
  height: 100%;
  margin-right: -10px;
  width: 0;
}

.progress-bar:after {
  content: none !important;
}

.progress-bar-container {
  background-color: transparent;
  height: 0.8rem;
  margin-left: -5px;
}

.progress-bar-label,
.progress-bar-link {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
}

.progress-bar-link {
  text-decoration: underline;
}

.progress-row {
  align-items: center;
  background-color: rgb(236, 236, 236);
  display: flex;
  height: inherit;
  width: inherit;
}

.rounded-left-edge {
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}

.rounded-right-edge {
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
}

.status-incomplete {
  background-color: rgb(247, 148, 030) !important;
}

.status-in-progress {
  background-color: rgb(053, 151, 236) !important;
}

.status-complete {
  background-color: rgb(000, 168, 155) !important;
}


.progress-bar-label {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  margin-top: 10px; /* Adjust to ensure it's not overlapping */
  display: inline-block;
  position: relative;
  z-index: 1; /* Ensure the label appears above other elements if needed */
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/graphs/progress-bar/progress-bar.component.css"],"names":[],"mappings":"AAAA;EACE,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;;AAGA;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB,EAAE,0CAA0C;EAC5D,qBAAqB;EACrB,kBAAkB;EAClB,UAAU,EAAE,4DAA4D;AAC1E","sourcesContent":[":host {\n  width: 0;\n}\n\n:root {\n  --color-blue: rgb(053, 151, 236);\n  --color-green: rgb(000, 168, 155);\n  --color-orange: rgb(247, 148, 030);\n}\n\na {\n  color: black;\n  text-decoration: underline;\n}\n\n.active-label {\n  font-weight: bold;\n  text-decoration: none;\n}\n\n.current {\n  font-weight: bold;\n  text-decoration: none;\n}\n\n.progress-bar {\n  display: inline-block;\n  height: 100%;\n  margin-right: -10px;\n  width: 0;\n}\n\n.progress-bar:after {\n  content: none !important;\n}\n\n.progress-bar-container {\n  background-color: transparent;\n  height: 0.8rem;\n  margin-left: -5px;\n}\n\n.progress-bar-label,\n.progress-bar-link {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 18px;\n}\n\n.progress-bar-link {\n  text-decoration: underline;\n}\n\n.progress-row {\n  align-items: center;\n  background-color: rgb(236, 236, 236);\n  display: flex;\n  height: inherit;\n  width: inherit;\n}\n\n.rounded-left-edge {\n  border-bottom-left-radius: 10px;\n  border-top-left-radius: 10px;\n}\n\n.rounded-right-edge {\n  border-bottom-right-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.status-incomplete {\n  background-color: rgb(247, 148, 030) !important;\n}\n\n.status-in-progress {\n  background-color: rgb(053, 151, 236) !important;\n}\n\n.status-complete {\n  background-color: rgb(000, 168, 155) !important;\n}\n\n\n.progress-bar-label {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 18px;\n  margin-top: 10px; /* Adjust to ensure it's not overlapping */\n  display: inline-block;\n  position: relative;\n  z-index: 1; /* Ensure the label appears above other elements if needed */\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
